export var ZoomFitEnum;
(function (ZoomFitEnum) {
    // eslint-disable-next-line no-unused-vars
    ZoomFitEnum[ZoomFitEnum["ACTUAL"] = 0] = "ACTUAL";
    // eslint-disable-next-line no-unused-vars
    ZoomFitEnum[ZoomFitEnum["WIDTH"] = 1] = "WIDTH";
    // eslint-disable-next-line no-unused-vars
    ZoomFitEnum[ZoomFitEnum["HEIGHT"] = 2] = "HEIGHT";
    // eslint-disable-next-line no-unused-vars
    ZoomFitEnum[ZoomFitEnum["FULL"] = 3] = "FULL";
    ZoomFitEnum[ZoomFitEnum["FREE"] = 4] = "FREE";
})(ZoomFitEnum || (ZoomFitEnum = {}));
export var PLAYSTATE;
(function (PLAYSTATE) {
    PLAYSTATE[PLAYSTATE["live"] = 0] = "live";
    PLAYSTATE[PLAYSTATE["play"] = 1] = "play";
    PLAYSTATE[PLAYSTATE["stop"] = 2] = "stop";
    PLAYSTATE[PLAYSTATE["pause"] = 3] = "pause";
    PLAYSTATE[PLAYSTATE["rewind"] = 4] = "rewind";
    PLAYSTATE[PLAYSTATE["trackRewind"] = 5] = "trackRewind";
    PLAYSTATE[PLAYSTATE["setAutoStop"] = 6] = "setAutoStop";
    PLAYSTATE[PLAYSTATE["unsetAutoStop"] = 7] = "unsetAutoStop";
})(PLAYSTATE || (PLAYSTATE = {}));
//# sourceMappingURL=RendererEnums.js.map